import { getAdvertisers2 } from '@/api/open'
import { uploadKuaishouAdvertiser } from '@/api/open'
import KuaishouUpload from '@/components/kuaishou-upload/KuaishouUpload.vue'
import AdvSelect from '@/components/adv-select/AdvSelect.vue'
import AdvsSelect from '@/components/adv-select/AdvSelect.vue'

export default {
    components: {
        KuaishouUpload,
        AdvSelect,
        AdvsSelect
    },
    props: {
        showUpload: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    created() {
      this.actionName = '添加'
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            corporations: [],
            loading: false,
            rules: {
                name: [{ required: true, message: '请填写素材名称', trigger: 'change' }],
                advertiser_id: [{ required: true, message: '请选择广告主', trigger: 'change' }],
                file_url: [{ required: true, message: '请上传文件', trigger: 'change' }],
                advertiser_ids: [{ required: true, message: '请选择广告主', trigger: 'change' }],
            },
            actionName: '操作',
            titles: [],
            show: false,
            treeData: [],
            replaceFields: {
                title: 'name',
                key: 'id',
                value: 'id'
            },
            showSize: 0,
            pid: null,
            materials: [], //上传的多个素材
            uploadedMaterials: [], //上传成功的素材
            uploadTypes: [{name: '单广告主',id: 1},{name: '多广告主',id: 2}],
            upload_type: 1, //上传模式：1-单广告主 2-多广告主
            advertisers: [],
        }
    },
    computed: {
        actType() {
            return this.actionName
        }
    },
    mounted() {
    
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            let data = Object.assign({}, this.model)
            if (!data.advertiser_id) {
                data.advertiser_id = this.materials[0].advertiser_id || null
            }
            data.materials = this.materials
            console.log('提交的数据', data)

            this.loading = true
            uploadKuaishouAdvertiser(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('上传成功')
                    // this.$emit('success')
                    // this.close()
                  
                    this.uploadedMaterials.push(data.materials[0].code)
                    // console.log('this.uploadedMaterials', this.uploadedMaterials, data.materials[0].code)
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            // this.$refs.form.resetFields()
            this.$emit('update:showUpload', false)
        },
        handleAfterUpload(data) {
            // 在这里处理从子组件返回的数据
            // console.log('上传后返回的数据', data);
            if (!data || data.length == 0) {
                return false
            }

            let length = data.length
            let returnMaterial = data[length - 1]
            console.log('当前返回的数据：', returnMaterial);
            if (!returnMaterial) {
                return false
            }

            // console.log('this.uploadedMaterials  2', this.uploadedMaterials)
            //如果md5成功成功过，返回
            if (this.uploadedMaterials.includes(returnMaterial.md5)) {
               return false 
            }

            if (this.upload_type == 2 && returnMaterial.advertiser_id) {
                const adv = this.advertisers.find(a => a.id === returnMaterial.advertiser_id)
                if (adv) {
                    // 若用户手动切过开关，就能直接读到；否则默认为 false
                    this.model.shield_backward_switch = adv.shield_backward_switch ?? false
                } else {
                    this.model.shield_backward_switch = false
                }
            }
           
            
            //最后一个是最新的， 返回就直接传到户
            this.materials = [
                {
                    name: returnMaterial.name,
                    blob_store_key: returnMaterial.blob_store_key,
                    code: returnMaterial.md5,
                    advertiser_id: returnMaterial.advertiser_id
                }
            ]
           
            // console.log('this.materials', this.materials);
            this.storeOrUpdate()

            // this.materials = []

            // data.forEach(element => {
            //     const thisData = {};
            //     thisData.name = element.name
            //     thisData.blob_store_key = element.blob_store_key
            //     thisData.code = element.md5
            //     thisData.advertiser_id = element.advertiser_id
            //     this.materials.push(thisData)
            // });

            // console.log('最终的materials数据', this.materials);

        },
        changeAdvertiserIds () {
            if (this.model.advertiser_ids.length>0) {
                getAdvertisers2({id: this.model.advertiser_ids, type:'kuaishou'}, 'kuaishou').then(res => {
                    let values = []
                    res.data.list.forEach(item => {
                        values.push({ id: item.id,advertiser_id: item.out_id, name: item.name, remark: item.remark, file_url:null })
                    })
                    this.advertisers = values
                })
            } else {
                this.advertisers = []
            }
          
        },
        changeUploadType() {
            this.model.advertiser_id = null
            this.model.advertiser_ids = null
            this.advertisers = []
        },
        handleClear () {
             // 清除单广告主上传的文件
            if (this.$refs.uploadRef && this.upload_type !== 2) {
                this.$refs.uploadRef.clearFiles()
            }
        
            // 清除多广告主的上传文件
            if (this.upload_type === 2 && this.advertisers.length > 0) {
                this.advertisers.forEach((adv, index) => {
                const refName = 'uploadRef_' + index
                const uploader = this.$refs[refName]
                // 注意 uploader 可能是数组，a-tabs 里的 ref 会是数组结构
                if (Array.isArray(uploader)) {
                    uploader[0]?.clearFiles?.()
                } else {
                    uploader?.clearFiles?.()
                }
                })
            }
        },
    }
}
